import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { isTokenValid } from "../services/auth";


const excludedPaths = ["/login", "/public"];

const AuthWrapper = ({ children }) => {
    const location = useLocation();

    const isExcluded = excludedPaths.includes(location.pathname);
    const isValid = isTokenValid();

    console.log("Valid", isValid)

    if (!isExcluded && !isValid) {
        console.log("Going to login");
        return <Navigate to="/login" replace />;
    }

    return children;
}

export default AuthWrapper;